import { defineMessages } from 'react-intl';

type MessageKeys = 'defaultGreetingText';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		defaultGreetingText: {
			id: 'rovo-chat.greeting-card.default-greeting-text',
			defaultMessage: 'How can I help, {name}?',
			description:
				'The default text displayed in the Rovo Greeting to prompt the user to ask a question.',
		},
	});

export default message;
